// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__XNO+2","table":"styles_table__N2vF5","trBorderTop":"styles_trBorderTop__M-VEh","noBold":"styles_noBold__jOl-y"};